// Relation display helper — maps legacy stored values to their new display labels
// without altering any stored data.
//
// Rules (per spec):
//  - "Director" (legacy) → shown as "Controlling Person"
//  - "LP" (removed from dropdown but still valid in old records) → shown as "LP"
//  - Anything else (Employee/Investor/GP/Fund/Others/Controlling Person/unknown) → shown as-is
//
// This helper is READ-ONLY: the underlying DB value is never rewritten.
export function displayRelation(raw) {
  if (raw === undefined || raw === null) return '';
  const v = String(raw).trim();
  if (!v) return '';
  if (v === 'Director') return 'Controlling Person';
  return v;
}

// Canonical list of currently-selectable options (used as fallback when the
// backend's /accounts default_relations payload is not yet loaded).
export const RELATION_OPTIONS = ['Employee', 'Investor', 'Controlling Person', 'GP', 'Fund', 'Others'];
